import type { ReactNode } from 'react';

export const symbol_align_flex_center: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M468.5-88.63Q460-97.25 460-110v-320H140q-12.75 0-21.37-8.63Q110-447.25 110-460v-40q0-12.75 8.63-21.38Q127.25-530 140-530h320v-320q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v320h300q12.75 0 21.38 8.62Q850-512.75 850-500v40q0 12.75-8.62 21.37Q832.75-430 820-430H520v320q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Z"
		/>
	</svg>
);
